import { isFocusAtStackRoot } from 'owa-calendar-focus-manager';
import { getCommands } from 'owa-calendar-hotkeys';
import type { SearchBoxContainerHandle } from 'owa-search';
import { useGlobalHotkey } from 'owa-hotkeys';
import type { SkipLinkPlaceholderHandle } from 'owa-skip-link';
import type * as React from 'react';

let hotkeysEnabled: boolean = true;

export function useCalendarModuleHotkeys(
    moduleSkipLinkRef: React.RefObject<SkipLinkPlaceholderHandle>,
    moduleSearchBoxRef: React.RefObject<SearchBoxContainerHandle>
) {
    const commands = getCommands();
    // default options are: preventDefault: true, stopPropagation: true, allowHotkeyOnTextFields: false
    useGlobalHotkey(commands.focusSkipLinks, focusSkipLinks, {
        allowHotkeyOnTextFields: true,
        isEnabled,
    });

    useGlobalHotkey(commands.gotoSearch, gotoSearch, { isEnabled });

    function gotoSearch() {
        if (moduleSearchBoxRef) {
            moduleSearchBoxRef.current.setFocus();
        }
    }

    function focusSkipLinks() {
        if (moduleSkipLinkRef) {
            moduleSkipLinkRef.current.focus();
        }
    }
}

export function disableCalendarModuleHotkeys() {
    hotkeysEnabled = false;
}

export function enableCalendarModuleHotkeys() {
    hotkeysEnabled = true;
}

function isEnabled() {
    // we want to disable hotkeys if there are any fabric popups open, not just ones the surface owns, so check for those separately
    return hotkeysEnabled && isFocusAtStackRoot();
}
